// extracted by mini-css-extract-plugin
export default {"switchCustomSourceContainer":"TrustedSourcePreferenceBlock_switchCustomSourceContainer__ne2oP"};